import React, { useEffect, useRef, useState } from 'react';

import StatusDot from './StatusDot';
import { usePresence } from '../../provider/PresenceProvider';

const STATUS_LABELS = {
  online: 'Available',
  away: 'Away',
  busy: 'Busy',
  idle: 'Idle',
  offline: 'Appear offline',
};

const MANUAL_OPTIONS = ['online', 'busy', 'away', 'offline'];

const StatusSelector = () => {
  const { status, manualStatus, setManualStatus } = usePresence();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  const handlePick = (s) => {
    setManualStatus(s);
    setOpen(false);
  };

  const handleReset = () => {
    setManualStatus(null);
    setOpen(false);
  };

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          padding: '4px 8px',
          borderRadius: 6,
          background: 'transparent',
          border: '1px solid var(--cx-line)',
          cursor: 'pointer',
          fontSize: 12,
          color: '#374151',
        }}
        title="Set your availability"
      >
        <StatusDot status={status} size={9} />
        <span>{STATUS_LABELS[status] || status}</span>
        <span style={{ opacity: 0.5, fontSize: 12 }}>▾</span>
      </button>
      {open && (
        <div
          style={{
            position: 'absolute',
            top: 'calc(100% + 4px)',
            right: 0,
            background: 'var(--cx-surface)',
            border: '1px solid var(--cx-line)',
            boxShadow: '0 6px 24px rgba(0,0,0,0.12)',
            borderRadius: 8,
            minWidth: 200,
            zIndex: 1000,
            padding: 4,
          }}
        >
          {MANUAL_OPTIONS.map((s) => (
            <button
              key={s}
              type="button"
              onClick={() => handlePick(s)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                width: '100%',
                padding: '8px 10px',
                background: manualStatus === s ? '#f3f4f6' : 'transparent',
                border: 'none',
                cursor: 'pointer',
                textAlign: 'left',
                fontSize: 13,
                borderRadius: 6,
                color: '#111827',
              }}
            >
              <StatusDot status={s} size={10} />
              <span>{STATUS_LABELS[s]}</span>
            </button>
          ))}
          <div style={{ height: 1, background: 'light-dark(#e5e7eb, #20242b)', margin: '4px 0' }} />
          <button
            type="button"
            onClick={handleReset}
            disabled={!manualStatus}
            style={{
              width: '100%',
              padding: '8px 10px',
              background: 'transparent',
              border: 'none',
              cursor: manualStatus ? 'pointer' : 'not-allowed',
              textAlign: 'left',
              fontSize: 12,
              color: manualStatus ? '#374151' : '#9ca3af',
              borderRadius: 6,
            }}
          >
            Reset to automatic
          </button>
        </div>
      )}
    </div>
  );
};

export default StatusSelector;
